<div class="checkbox-container">
  <div class="checkbox clickable" (click)="toggle()">
    <div class="checked-area" [class.active]="active"></div>
  </div>
  <ng-content></ng-content>
</div>
